import React, { ReactNode } from 'react'
import { View } from '@/components'
import { CommunityFeed } from '@/types'
import { ReportOverlay } from '../../organisms/ReportOverlay'
import { Volume } from './Volume'
import { Like } from './Like'
import { Comment } from './Comment'
import { Share } from './Share'
import { Report } from './Report'

const disabledTypes: CommunityFeed['type'][] = ['hurdle', 'profile_prompt']

type IFeedItemActions = 'volume' | 'like' | 'share' | 'report'

type FeedItemActionsProps = {
  item: CommunityFeed
  actions?: { [x in IFeedItemActions]?: boolean }
  children?: ReactNode
}

const initialActions: Record<IFeedItemActions, boolean> = {
  volume: true,
  like: true,
  share: true,
  report: true,
}

export function FeedItemActions(props: FeedItemActionsProps) {
  const { item, children, actions = initialActions } = props

  const isReported = ReportOverlay.useIsReported(item?.id)

  const showComment = item?.type !== 'prompt'

  if (disabledTypes.includes(item.type)) return <>{children}</>

  return (
    <View variants={['column', 'center', 'gap:2']}>
      <View variants={['column', 'center', 'gap:2']} style={{ pointerEvents: isReported ? 'none' : 'auto' }}>
        {actions?.volume ? <Volume item={item} /> : null}
        {actions?.like ? <Like item={item} /> : null}
        {showComment ? <Comment item={item} /> : null}
        {actions?.share ? <Share item={item} /> : null}
        {actions?.report ? <Report item={item} /> : null}
      </View>

      {children}
    </View>
  )
}
